export function getInterviewPacks(topicsData) {
  return Array.isArray(topicsData?.topic_sets) ? topicsData.topic_sets : [];
}

export function getPracticeSelectorItems(
  isInterviewPractice,
  interviewPacks,
  oralTopics
) {
  return isInterviewPractice ? interviewPacks : oralTopics;
}

export function buildInterviewStartPayload(basePayload, selectedPackId) {
  return {
    ...basePayload,
    practice_type: "interview_practice",
    standard: "general",
    level_id: "general",
    language_id: "english",
    topic_set_id: selectedPackId,
    topic_id: selectedPackId,
    activity_set_id: selectedPackId,
    question_set_id: selectedPackId,
    rubric_mode: "interview_general",
  };
}
